export const defaultRelations = [
  "big-numbers-display.bigNumbers",
  "provider-slider-display.providerSlider",
  "sub-landing-links-display.subLandingLinks",
  "media-reviews-display.mediaReviews",
  "client-reviews-display.clientReviews",
  "faq.reviewer",
  "author-review.author",
  "banner-slideshow.banners",
  "post.author",
  "post.specialist",
  "post.relatedPosts",
  "slide-banner.banner",
  "hero-tiles.googleRating",
  "hero-landing.googleRating",
  "hero-about.googleRating",
];
